import React, { useMemo, Fragment } from 'react'

const HeraldSection = ({
  preHeadline,
  headline,
  caption,
  story,
  quote,
  image,
  headlineStyle = 'hl1',
  captionStyle = 'hl2',
}) => {
  const paragraphs = useMemo(() => {
    return story.split("\n").filter(p => p && p.length > 0)
  }, [
    story,
  ])

  return (
    <div className="collumn">
      <div className="head">
        {
          preHeadline && (
            <p>
              <span className={`headline`}>
                { preHeadline }
              </span>
            </p>
          )
        }
        <span className={`headline ${headlineStyle}`}>
          { headline }
        </span>
        <p>
          <span className={`headline ${captionStyle}`}>
            { caption }
          </span>
        </p>
      </div>
      {
        paragraphs.map((p, i) => {
          return (
            <Fragment key={i}>
              <p>{ p }</p>
              {
                i == 0 && image && (
                  <figure className="figure">
                    <img className="media" src={ image.url } alt={ image.caption } />
                    <figcaption className="figcaption">
                      <a href={ image.url } target="_blank">{ image.caption }</a>
                    </figcaption>
                  </figure>
                )
              }
              {
                i == 1 && quote && (
                  <span className="citation">
                    { quote }
                  </span>
                )
              }
            </Fragment>
          )
        })
      }
      {/* <p>
        Partially, but it also obeys your commands. Hey, Luke! May the Force be with you. I have traced the Rebel spies to her. Now she is my only link to finding their secret base.
      </p>
      <figure className="figure">
        <img className="media" src="http://i.giphy.com/4fDWVPMoSyhgc.gif" alt="" />
        <figcaption className="figcaption">
          "This time, let go your conscious self and act on instinct."
        </figcaption>
      </figure>
      <p>Leave that to me. Send a distress signal, and inform the Senate that all on board were killed.</p>
      <span className="citation">"Don't under&shy;estimate the Force. I suggest you try it again, Luke."</span>
      <p>This time, let go your conscious self and act on instinct. In my experience, there is no such thing as luck. You're all clear, kid. Let's blow this thing and go home!</p>
      <p>You don't believe in the Force, do you? Partially, but it also obeys your commands. The plans you refer to will soon be back in our hands. As you wish.</p> */}
    </div>
  )
}


export default HeraldSection